<template>
    <div class="index" v-loading.body="isFullLoading">
        <xi-top></xi-top>
        <div class="banner-out-wrapper swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide banner">
                    <div class="banner-inner-wrapper">
                        <div class="large-slogan">
                            <p>让你的作品有声</p>
                            <p>这里·有4亿用户在听</p>
                        </div>
                        <div class="sub-slogan">
                            <span><span class="em">3000</span> 位专业主播为你讲述，<span class="em">10万 </span>部著作等你来读</span>
                        </div>
                    </div>
                </div>
                <a v-for="pic in pictures" :style="{backgroundImage: 'url(' + $store.state.UPLOAD_IMG_HOST + pic.picUrl + ')'}" class="swiper-slide" @click="sendClickLog" :href="`${pic.linkUrl}`">
                </a>
            </div>
            <div class="swiper-pagination"></div>
        </div>
        <div class="navigator-out-wrapper">
            <div class="navigator-inner-wrapper">
                <router-link class="nav-item" :to="{name: 'copyrighterIndex'}">
                    <i class="icon icon-copyright icon-80"></i>
                    <span class="title">我有好作品</span>
                    <span class="sub-title">————  我要找主播  ————</span>
                </router-link>
                <router-link class="nav-item" :to="{name: 'anchorIndex'}">
                    <i class="icon icon-microphone icon-80"></i>
                    <span class="title">我有好声音</span>
                    <span class="sub-title">————  我要找作品  ————</span>
                    <!--<div class="cover"></div>-->
                </router-link>
                <a class="nav-item">
                    <i class="icon icon-post icon-80"></i>
                    <span class="title">我会后期</span>
                    <span class="sub-title">————  我要找后期工作  ————</span>
                    <div class="cover">
                        <span class="title" style="margin-top: 100px;">敬请期待</span>
                    </div>
                </a>
            </div>
        </div>
        <div class="anchor-wrapper">
            <div class="anchor-content-wrapper">
                <span class="title">在这里的主播</span>
                <div class="items">
                    <a :href="getAnchorLink(anchor)" target="_blank" class="item" v-for="anchor in excellentAnchors">
                        <img :src="getUploadImg(anchor.logoPic)">
                        <span class="single-name">{{ anchor.nickname }}</span>
                        <div class="content">
                            <span class="title">{{ anchor.nickname }}</span>
                            <span class="sub-title s-sub-title">{{ anchor.personalSignature || '无' }}</span>
                            <div class="data">
                                <i class="icon icon-played"></i>
                                <span v-if="anchor.anchorStatCount && anchor.anchorStatCount.trackCount">
                                {{ anchor.anchorStatCount.trackCount | formatNumber }}
                                </span>
                                <span v-else>0</span>
                                <i class="icon icon-fans"></i>
                                <span v-if="anchor.anchorStatCount && anchor.anchorStatCount.followCount">
                                    {{ anchor.anchorStatCount.followCount | formatNumber }}
                                </span>
                                <span v-else>0</span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <div class="author-wrapper">
            <div class="author-content-wrapper">
                <span class="title">已入驻的作家</span>
                <div class="items">
                    <div class="item-first">
                        <img :src="getUploadImg(authors[0].logoPic)">
                        <div class="content">
                            <span class="title">{{ authors[0].name }}</span>
                            <!--<a :href="getAuthorLink(authors[0])" class="title" target="_blank">{{ authors[0].name }}</a>-->
                            <!--<el-tooltip :content="authors[0].intro" placement="top" popper-class="desc-popper">-->
                                <p class="big-desc">
                                    {{ authors[0].intro }}
                                </p>
                            <!--</el-tooltip>-->
                        </div>
                    </div>
                    <div class="item-left">
                        <div class="item" v-for="(author, index) in authors" v-if="index > 0">
                            <img :src="getUploadImg(author.logoPic)">
                            <div class="content">
                                <span class="title">{{ author.name }}</span>
                                <!--<a :href="getAuthorLink(author)" class="title" target="_blank">{{ author.name }}</a>-->
                                <el-tooltip :content="author.intro" placement="top" popper-class="desc-popper">
                                    <p class="desc">
                                        {{ author.intro }}
                                    </p>
                                </el-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="cooperator-out-wrapper">
            <div class="cooperator-inner-wrapper">
                <span class="title">合作版权机构</span>
                <div class="items">
                    <img v-for="brandCover in publishers" :src="getUploadImg(brandCover.logoPic)">
                </div>
            </div>
        </div>
        <xi-footer></xi-footer>
    </div>
</template>
<script>
  import axios from 'axios';
  import XiFooter from './components/Footer.vue';
  import XiTop from './components/Top.vue';
  import shave from 'shave';
  import swiper from 'swiper';
  export default {
    components: {
      axios,
      XiFooter,
      XiTop
    },
    data() {
      return {
        pictures: [],
        excellentAlbums: [],
        preTasks: [],
        excellentAnchors: [{
          anchorStatCount: {
            followCount: 0,
            trackCount: 0
          }
        }],
        publishers: [],
        authors: [{logoPic: ''}],
        popData: {
          prePay: {
            direct: {

            }
          }
        },
        isFullLoading: true,
        isPopLoading: false
      }
    },
    methods: {
      getHomeInfo () {
        const that = this;
        axios.get('/api/home/info').then( res => {
          that.isFullLoading = false;
          if(res.data.code === 200) {
            that.excellentAnchors = res.data.data.excellentAnchors;
            that.pictures = res.data.data.pictures;
            that.excellentAlbums = res.data.data.excellentAlbums;
            that.publishers = res.data.data.publishingHouses;
            that.authors = res.data.data.authors;
          } else {
            that.$message({
              message: res.data.message,
              type: 'warning'
            });
          }
        });
      },
      getPreTasks () {
        axios.get('/api/requirement/pre/publish/list/1/8').then(res => {
          if(res.data.code === 200) {
            this.preTasks = res.data.data.items;
            this.isFullLoading = false;
          } else {
            this.message({
              message: res.data.message,
              type: 'warning'
            })
          }
        });
      },
      showTask (requirementId) {
        this.isPopLoading = true;
        axios.get(`/api/requirement/detail/requirementId/${requirementId}`).then( res => {
          if(res.data.code === 200) {
            this.popData = res.data.data;
            this.isPopLoading = false;
          }
        });
        this.isVisible = true;
      },
      getAlbumLink (info) {
        return this.$store.state.XMLY_INDEX_URL + info.uid + '/album/' + info.albumId + '/';
      },
      getAnchorLink (info) {
        return this.$store.state.XMLY_INDEX_URL + 'zhubo/' +info.uid;
      },
      getAuthorLink (info) {
        return info.linkUrl? info.linkUrl: false;
      },
      getUploadImg(logo) {
        let reg = new RegExp('^http://');
        return logo? (reg.test(logo)? logo:this.$store.state.UPLOAD_IMG_HOST + logo)
          : 'http://s1.xmcdn.com/css/img/common/default/user110.jpg';
      },
      getCoverImg(logo) {
        let reg = new RegExp('^http://');
        return reg.test(logo)? logo:this.$store.state.UPLOAD_IMG_HOST + logo;
      },
      toCenter () {
        if (this.$store.state.user.author.authorProgressStatus === 0) {
          this.$router.push({name: 'innerEnterGuiding'});
        } else {
          this.$router.push({name: 'worksManagement'});
        }
      },
      sendClickLog () {
        xmLog('pv.send', 'event', {
          serviceId: "aBookPageClick",
          item: 'button',
          srcPage: '有声化平台首页',
          srcModule: '轮播图',
          srcPosition: 2,
          itemId: '专题'
        });
      },
      changeImage (curIndex) {
        this.$refs.carousel.$el.style.backgroundColor = this.pictures[curIndex].bgColor;
      },
      shave() {
        shave('.big-desc', 270);
        shave('.desc', 80);
        shave('.s-sub-title', 70);
      },
      setXMLog () {
        xmLog('pv.create', {
          item: "有声化平台首页"
        }),
        xmLog("pv.send", "event", {
          serviceId: "aBookView",
          item: "有声化平台首页"
        })
      },
      initSwiper () {
        new swiper('.swiper-container', {
          loop: true,
          speed: 300,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          }
        });
      }
    },
    computed: {
      IMG_HOST(){
        return this.$store.state.IMG_HOST;
      }
    },
    mounted () {
      // 埋点
      this.getHomeInfo();
      this.setXMLog();
    },
    updated () {
      this.initSwiper();
      this.shave();
    }
  }

</script>
<style lang="sass">
    @import "../sass/index.scss";
    @import "../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// Index.vue?e041d8f0